import { LeaderboardBrand } from "../Leaderboard";
import "./index.scss";

interface LeaderboardBannerProps {
  brand: LeaderboardBrand;
  promotionAsset?: string | null;
  from: string;
  to: string;
}
export const LeaderboardBanner = (props: LeaderboardBannerProps) => (
  <div className="leaderboard-banner">
    {/* <h1>Affiliate Leaderboard</h1> */}
    {props.promotionAsset && (
      <div id="leaderboard-banner-title-img">
        <img src={props.promotionAsset} alt="Leaderboard banner" />
      </div>
    )}
    <div className="promotion">
      <span>Legends that used code </span>
      <span className="code">BUDI</span>
      <span>on</span>
      <span>
        <img
          src={`/assets/${props.brand.toLowerCase()}-logo.png`}
          alt="CSGORoll logo"
        />
      </span>
    </div>
    <h3>
      {props.from} - {props.to}.
    </h3>
    <span className="thankyou">Thank you so much for your support ❤️</span>

    <h1 className="discord-link">
      <a href="https://discord.gg/smqHmfz2QK" target="_blank" rel="noreferrer">
        🤑 FREE SPONSORED BATTLES on Discord EVERY DAY 🤑
      </a>
    </h1>

    <div className="feb-leaderboard-banners">
      <img src="/assets/leaderboard10k.png" alt="10k banner" />
      <img src="/assets/10x500.png" alt="5k banner" />
    </div>
  </div>
);
